import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';

const Hero = ({ themeMode = 'light' }) => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage:
              themeMode === 'dark'
                ? 'url(/images/logos/logo_white.PNG)'
                : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '16vh',
          }}
        />
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Propuesta Comercial
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h3"
          gutterBottom
          align="center"
          color={theme.palette.primary.main}
        >
          Lácteos Barinas & TNO Network
        </Box>
        <Typography
          variant="h6"
          component="p"
          color="textSecondary"
          align="center"
          sx={{ fontStyle: 'italic', mb: 3 }}
        >
          Estrategia de Posicionamiento, Nutrición y Confianza Digital
        </Typography>
        <Box
          sx={{
            maxWidth: 720,
            mx: 'auto',
            py: 2,
            px: 2,
            borderRadius: 2,
            bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
          }}
        >
          <Typography
            variant="h6"
            component="p"
            color="textSecondary"
            align="center"
            gutterBottom
          >
            <strong>Análisis de Oportunidad</strong>
          </Typography>
          <Typography variant="body1" color="textSecondary" align="center">
            Lácteos Barinas representa la frescura del campo y la nutrición esencial. En el ecosistema de <strong>TNO</strong>, conectamos esa tradición con una audiencia moderna que busca bienestar y practicidad. Como <strong>medio innovador</strong>, integramos tecnología y narrativa para que su marca no solo se vea, sino que se convierta en parte del hábito de consumo de nuestra comunidad.
          </Typography>
        </Box>
        <Box
          sx={{
            maxWidth: 560,
            mx: 'auto',
            mt: 3,
            py: 1.5,
            px: 2,
            borderRadius: 2,
            border: `2px solid ${theme.palette.primary.main}`,
            bgcolor: theme.palette.primary.main + '14',
          }}
        >
          <Typography variant="body1" align="center" fontWeight={600} color="primary">
            Modalidad de inversión: 50% intercambio por productos + 50% en efectivo.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

Hero.propTypes = {
  themeMode: PropTypes.string,
};

export default Hero;
